import * as ActionTypes from './ActionTypes'

export function setShouldUpdate(shouldUpdateValue) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNUPDATE_MANAGER_SET_SHOULD_UPDATE,
      shouldUpdateValue,
    })
  }
}

export function setShouldShowUpdateModal(shouldShowUpdateModalValue) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNUPDATE_MANAGER_SET_SHOULD_SHOW_UPDATE_MODAL,
      shouldShowUpdateModalValue,
    })
  }
}

export function setUpdateAvailable(updateAvailableValue) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNUPDATE_MANAGER_SET_UPDATE_AVAILABLE,
      updateAvailableValue,
    })
  }
}
